# import SubscriptionFragment from '../fragments/subscription.graphql'

query SubscriptionsQuery($company_id: ID!) {
  subscriptions(company_id: $company_id) {
    ...SubscriptionFragment
  }
}
